import { Injectable } from '@angular/core';

import { HttpService } from '../../http.service';
import { Observable, Subject } from '../../util/rxjs';
import { FileUpload, UploadStatus } from './file-upload.model';

interface fileUpload {
  status: any;
  upload: any;
  file: any;
  progress: any;
  name: any;
}

@Injectable()
export class FileUploadService {
  files: FileUpload[] = [];
  uploadFinished$: Observable<FileUpload>;

  uploadUrl: (file: FileUpload) => string;
  deleteUrl: (file: FileUpload) => string;
  deleteAllUrl: () => string;

  private uploadFinishedStream = new Subject<FileUpload>();

  constructor(private http: HttpService) {
    this.uploadFinished$ = this.uploadFinishedStream.asObservable();
  }

  upload(file: File) {
    if (this.hasDuplicate(file)) {
      this.files.push(this.toUploadedFile(file, UploadStatus.Duplicate));
    } else {
      this.files.push(this.toUploadedFile(file, UploadStatus.Ready));
    }
    this.startNextUpload();
  }

  remove(file: FileUpload) {
    if (file.status === UploadStatus.Uploading && file.upload) {
      file.upload.unsubscribe();
    }

    if (file.status === UploadStatus.Uploading || file.status === UploadStatus.Complete) {
      this.http.delete(this.deleteUrl(file)).subscribe();
    }

    this.files.splice(this.files.findIndex(f => (f.name === file.name && f.status === file.status)), 1);
    this.startNextUpload()
  }

  removeAll() {
    this.http.delete(this.deleteAllUrl()).subscribe();
    this.files = [];
  }

  private startNextUpload() {
    const nextFile: fileUpload = this.findNextUpload();
    if (!nextFile) {
      return;
    }

    nextFile.status = UploadStatus.Uploading;
    nextFile.upload = this.http.uploadFile(this.uploadUrl(nextFile), nextFile.file)
      .subscribe(event => {
        nextFile.progress = event.progress;
      }, () => {
        nextFile.status = UploadStatus.Failed;
        nextFile.progress = 0;
        this.uploadFinishedStream.next(nextFile);
        this.startNextUpload();
      }, () => {
        nextFile.status = UploadStatus.Complete;
        nextFile.progress = 100;
        this.uploadFinishedStream.next(nextFile);
        this.startNextUpload();
      });
  }

  private toUploadedFile(file: File, status: UploadStatus): FileUpload {
    return {
      file,
      name: file.name,
      status: status,
      progress: 0
    };
  }

  private findNextUpload() {
    let fileToUpload: any = undefined;
    for (const file of this.files) {
      if (file.status === UploadStatus.Uploading) {
        return undefined;
      } else if (!fileToUpload && file.status === UploadStatus.Ready) {
        fileToUpload = file;
      }
    }
    return fileToUpload;
  }

  private hasDuplicate(file: File) {
    return this.files.findIndex(f => f.name === file.name) !== -1;
  }
}

